'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    'en-us': {
        file: {
            addPhoto: 'Add Photo'
        },
        image: {
            cancel: 'Cancel',
            addPhoto: 'Add Photo'
        },
        crop: {
            title: 'Upload',
            reset: 'Reset',
            save: 'Save and Close'
        },
        drag: {
            dragTips: 'Drag the file to the dashed box directly can be uploaded',
            dropTips: 'Drop it now'
        },
        error: {
            maxSize: 'file size exceeds limit',
            parseJson: 'The server needs to return a standard JSON string'
        }
    },
    'zh-cn': {
        file: {
            addPhoto: '上传照片'
        },
        image: {
            cancel: '取消',
            addPhoto: '上传照片'
        },
        crop: {
            title: '上传',
            reset: '重新选择',
            save: '保存并关闭'
        },
        drag: {
            dragTips: '直接拖动文件到虚线框内即可上传',
            dropTips: '可以放手了'
        },
        error: {
            maxSize: '文件尺寸超过限制',
            parseJson: '服务器需要返回标准 JSON 字符串'
        }
    },
    'zh-tw': {
        file: {
            addPhoto: '上傳照片'
        },
        image: {
            cancel: '取消',
            addPhoto: '上傳照片'
        },
        crop: {
            title: '上傳',
            reset: '重新選擇',
            save: '保存並關閉'
        },
        drag: {
            dragTips: '直接拖動文件到虛線框內即可上傳',
            dropTips: '可以放手了'
        },
        error: {
            maxSize: '文件尺寸超過限制',
            parseJson: '服務器需要返回標準 JSON 字符串'
        }
    }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-upload/lib/locale/index.js
// module id = 503
// module chunks = 0